var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-channels"},[_c('router-view',{attrs:{"channels":_vm.channels,"plans":_vm.plans,"isLoadingChannels":_vm.isLoadingChannels,"groupName":_vm.groupName},on:{"click-channel-item":_vm.clickChannelItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }